<template>
    <button
        :type="type"
        class="
            duration-50
            inline-flex
            items-center
            px-6
            py-3
            hover:text-gray-500
            focus:text-gray-500
            text-gray-600
            active:text-gray-800
            text-sm
            font-medium
            tracking-wide
            active:bg-gray-50
            bg-white
            border border-gray-300
            hover:border-gray-400
            rounded-md
            focus:outline-none
            shadow-sm
            uppercase
            transition
            ease-in-out
            hover:ring-2
            focus:ring-4
            hover:ring-gray-400 hover:ring-offset-2
        "
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        focus: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "button",
        },
    },

    watch: {
        focus(bool) {
            if (bool) {
                this.$el.focus()
            }
        },
    },

    methods: {
        blur() {
            this.$el.blur()
        },
    },
}
</script>
